import React from 'react';

const GradientInfoIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    strokeWidth={1.5}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <defs>
      <linearGradient
        id="infoIconGrad"
        x1="2"
        y1="2"
        x2="22"
        y2="22"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#22D3EE" />
        <stop offset="1" stopColor="#3B82F6" />
      </linearGradient>
    </defs>
    <circle cx="12" cy="12" r="10" stroke="url(#infoIconGrad)" />
    <path d="M12 16v-4" stroke="url(#infoIconGrad)" />
    <path d="M12 8h.01" stroke="url(#infoIconGrad)" />
  </svg>
);

export default GradientInfoIcon;
